import React, {useState, useEffect} from "react";
import "./DateInput.css";

const days = [
    "Jour",
    ...Array.from({length: 31}, (_, i) => i + 1)
];

const months = [
    "Mois",
    ...Array.from({length: 12}, (_, i) => i + 1)
];

const years = [
    "Année",
    ...Array.from({length: 100}, (_, i) => 2021 - i)
];

export const DateInput = ({date, setDate}) => {
    const [day, setDay] = useState("Jour");
    const [month, setMonth] = useState("Mois");
    const [year, setYear] = useState("Année");

    useEffect(() => {
        if (day !== "Jour" && month !== "Mois" && year !== "Année") {
            setDate(`${day}/${month}/${year}`);
        }
    }, [day, month, year, setDate]);

    return (
        <>
            <h1 className={"extra_text"}>Permettez-moi de contempler les étoiles, révélez-moi votre date de naissance.</h1>
            <div className={"date-container"}>
                <select className={"date-select"} value={day} onChange={(e) => setDay(e.target.value)}>
                    {days.map((day) => <option key={day} value={day}>{day}</option>)}
                </select>
                <select className={"date-select"} value={month} onChange={(e) => setMonth(e.target.value)}>
                    {months.map((month) => <option key={month} value={month}>{month}</option>)}
                </select>
                <select className={"date-select"} value={year} onChange={(e) => setYear(e.target.value)}>
                    {years.map((year) => <option key={year} value={year}>{year}</option>)}
                </select>
            </div>
        </>
    )
}